var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "Stepper" } }, [
    _c(
      "div",
      { staticClass: "stepper-container" },
      _vm._l(_vm.steps, function (step, index) {
        return _c(
          "div",
          {
            key: index,
            class: _vm.activeIndex === index ? "step active" : "step",
            on: {
              click: function ($event) {
                return _vm.stepClickHandler(index)
              },
            },
          },
          [
            index !== 0 && _vm.steps.length !== index
              ? _c(
                  "div",
                  { staticClass: "arrow" },
                  [_c("DynamicSvg", { attrs: { name: "Arrow" } })],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "circle" }, [
                _c(
                  "div",
                  { staticClass: "icon-container" },
                  [
                    _c("DynamicSvg", {
                      attrs: {
                        color: _vm.activeIndex === index ? "#EC4B1D" : "#333",
                        name: step.iconName,
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "title" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(step.title) +
                    "\n                "
                ),
              ]),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }